import React from 'react'
import CircularProgress from 'component/misc/CircularProgress'
import useBreakpoint from 'utils/useBreakPoint';
import { useNavigate } from "react-router-dom";
import { timeAgo } from "utils/timeAgo";
import { useTranslation } from "react-i18next";
import { translateSectorLabel } from "utils/sectorLabel";

const TopNews = ({ title, summary, _id, progress = 70, categories = [], image_url, sectors, created_at, reading_time_minutes }) => {
  const breakpoint = useBreakpoint();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleClick = () => {
    if (_id) navigate(`/news/news-view/${_id}`);
  };

  let imageSource = "";
try {
  if (image_url) {
    const urlObj = new URL(image_url);
    // Remove protocol and 'www.'
    imageSource = urlObj.hostname.replace(/^www\./, "");
  }
} catch (e) {
  imageSource = "";
}

  return (
    <div onClick={handleClick} style={{ cursor: _id ? "pointer" : "default" }}>
          <div className="latest_news_card  shadow-sm">
              <div className="latest_news_image_box position-relative">
                  <img
                      src={image_url}
                      alt={title || t("news.top.imageAlt")}
                      className="w-100 h-100 object-fit-cover rounded-4"
                  />
                  {imageSource && (
                    <span className="mini_title position-absolute">
                        {t("news.image.source")} {imageSource}
                    </span>
                    )}
              </div>
          </div>
          {/* Overlay */}
          <div className="latest_news_card_overlay ">
              <h3 className="fs_30 fw-light text-white mb-4">
                  {title}
              </h3>
              <p className="text-white fw-light mb-4">
                  {summary}
              </p>
              <div className="news_detail d-flex align-items-center justify-content-between">
                  <div className="d-flex gap-3 align-items-center small ">
                      {breakpoint === "laptop" && 
                      <p className="text-white mb-0">
                          <span className="active_news "></span>
                          {timeAgo(created_at)}
                      </p>
                      }
                      {sectors && sectors.slice(0, 2).map((sector, idx) => (
    <span key={idx} className='category rounded-4 text-white'>{translateSectorLabel(sector, i18n.resolvedLanguage || i18n.language)}</span>
  ))}
                  </div>
                  <div className="d-flex align-items-center gap-3 small">
                      <span className="post_time">{reading_time_minutes} {t("news.readTime.min")}</span>
                      <CircularProgress progress={progress} />
                  </div>
              </div>
          </div>
    </div>
  )
}

export default TopNews
